// extracted by css-extract-rspack-plugin
export default {"root":"styles_root__9+Mzl","header":"styles_header__U4Mv1","buttons":"styles_buttons__vRvpY","content":"styles_content__qvXmX"};